import React, { PureComponent } from "react";

import Branch from "./Branch";

import styles from "./Category.local.scss";
import classnames from "classnames";

import _ from "i18n";

export default class CategoryComponent extends PureComponent {
  state = {
    activateEdit: false,
    nodes: null,
    show: true
  };

  componentDidMount() {
    if (this.props.tree) {
      const { tree } = this.props.tree;
      this.setState({
        nodes: tree
      });
    }
  }

  getNodeChildren(children) {
    let nodes = [];
    let me = this;
    children.forEach(child => {
      if (child && child.ch)
        nodes.push({
          id: child.id,
          ch: me.getNodeChildren(child.ch)
        });
      else if (child) nodes.push({ id: child.id });
    });
    return nodes;
  }

  updateNodes(nodes, nodeId, parentId, oldTag, newTag) {
    const me = this;
    if (nodes && nodes.length > 0) {
      if (nodeId === parentId && nodes) {
        if (!oldTag)
          nodes.push({
            id: newTag.id,
            nameFr: newTag.nameFr,
            nameEn: newTag.nameEn,
            nameNl: newTag.nameNl,
            ch: []
          });
        else
          nodes.forEach(function(child, i) {
            if (oldTag.id === child.id) {
              nodes[i].id = newTag.id;
              nodes[i].nameFr = newTag.nameFr;
              nodes[i].nameEn = newTag.nameEn;
              nodes[i].nameNl = newTag.nameNl;
              return nodes;
            }
          });
      } else if (nodes) {
        nodes.forEach(function(child, y) {
          if (child.ch) {
            nodes[y].ch = me.updateNodes(
              child.ch,
              child.id,
              parentId,
              oldTag,
              newTag
            );
          }
        });
      }
    } else {
      if (nodeId === parentId)
        nodes.push({
          id: newTag.id,
          nameFr: newTag.nameFr,
          nameEn: newTag.nameEn,
          nameNl: newTag.nameNl,
          ch: []
        });
    }
    return nodes;
  }

  setEditionMode = id => {
    const { setCurrentTreeId } = this.props;
    setCurrentTreeId(id);
    if (!this.state.activateEdit) this.setState({ activateEdit: true });
  };

  handleDisableEdit = () => {
    const { setFilterNotIn } = this.props;
    this.setState({ activateEdit: false });
    this.setCurrentTreeId(null);
    setFilterNotIn([]);
  };

  setCurrentTreeId = id => {
    const { setCurrentTreeId } = this.props;
    setCurrentTreeId(id);
  };

  handleActivateEdit = id => {
    const { nodes } = this.state;
    this.setState({ activateEdit: true });
    this.setCurrentTreeId(id);
    this.updateFilter(nodes);
  };

  removeNode = (nodes, parentId, branchId) => {
    let indexElement = -1;
    if (nodes && nodes.id === parentId) {
      nodes.ch.forEach(function(node, index) {
        if (node.id === branchId) indexElement = index;
      });
      if (indexElement > -1) nodes.ch[indexElement] = null;
    } else if (nodes && nodes.ch) {
      nodes.ch.forEach((node, index) => {
        node = this.removeNode(node, parentId, branchId);
      });
    }
    return nodes;
  };

  handleRemove = (parentId, branchId) => {
    const { setOpenDeleteConfirm } = this.props;
    const nodes = { ...this.state.nodes };
    if (nodes.root) {
      let indexElement = -1;
      if (!parentId) {
        setOpenDeleteConfirm(true);
        // this.setState({
        //   nodes: null
        // });
      } else {
        if (nodes.root && nodes.root.id === parentId) {
          nodes.root.ch.forEach(function(node, index) {
            if (node && node.id === branchId) indexElement = index;
          });
        } else if (nodes.root && nodes.root.ch) {
          nodes.root.ch.forEach((child, index) => {
            child = this.removeNode(child, parentId, branchId);
          });
        }

        if (indexElement > -1) nodes.root.ch[indexElement] = null;

        this.setState({
          nodes
        });
      }
    }
  };

  setNodes(nodes) {
    this.setState(nodes);
  }

  handleChange = (parentId, oldTag, newTag) => {
    let nodes = null;
    nodes = this.state.nodes ? { ...this.state.nodes } : nodes;
    let me = this;
    if (!parentId) {
      if (!nodes)
        nodes = {
          root: {
            id: newTag.id,
            nameFr: newTag.nameFr,
            nameEn: newTag.nameEn,
            nameNl: newTag.nameNl,
            ch: []
          }
        };
      else if (oldTag && nodes.root && nodes.root.id === oldTag.id) {
        nodes.root.id = newTag.id;
        nodes.root.nameFr = newTag.nameFr;
        nodes.root.nameEn = newTag.nameEN;
        nodes.root.nameEn = newTag.nameEN;
      }
    } else {
      if (!oldTag)
        if (nodes && nodes.root && nodes.root.id === parentId)
          nodes.root.ch.push({
            id: newTag.id,
            nameFr: newTag.nameFr,
            nameEn: newTag.nameEn,
            nameNl: newTag.nameNl,
            ch: []
          });
        else {
          // if (nodes && nodes.root.id === parentId)
          //   nodes.root.ch.forEach(function(child, index) {
          //     if (child.id === newTag.id) nodes.root.ch[index].id = newTag.id;
          //   });
          // else if (nodes && nodes && nodes.root && nodes.root.ch)
          nodes.root.ch = me.updateNodes(
            nodes.root.ch,
            nodes.root.id,
            parentId,
            oldTag,
            newTag
          );
        }
      else if (nodes && nodes && nodes.root.id === parentId)
        nodes.root.ch.forEach(function(child, index) {
          if (child.id === oldTag.id) {
            nodes.root.ch[index].id = newTag.id;
            nodes.root.ch[index].nameFr = newTag.nameFr;
            nodes.root.ch[index].nameEn = newTag.nameEn;
            nodes.root.ch[index].nameNl = newTag.nameNl;
          }
        });
      else if (nodes && nodes && nodes.root && nodes.root.ch)
        nodes.root.ch = me.updateNodes(
          nodes.root.ch,
          nodes.root.id,
          parentId,
          oldTag,
          newTag
        );
    }
    this.updateFilter(nodes);
    this.setState({
      nodes
    });
  };

  extractIdsFromNodes = (nodes, ids) => {
    if (nodes && nodes.ch && nodes.ch.length > 0) {
      nodes.ch.forEach(child => {
        ids.push(child.id);
        ids = this.extractIdsFromNodes(child, ids);
      });
    }
    return ids;
  };

  updateFilter = nodes => {
    let ids = [];
    if (nodes && nodes.root) {
      ids.push(nodes.root.id);
      nodes.root.ch.forEach(child => {
        ids.push(child.id);
        ids = this.extractIdsFromNodes(child, ids);
      });
    } else if (nodes && nodes.ch && nodes.ch.length > 0) {
      nodes.ch.forEach(child => {
        ids.push(child.id);
        ids = this.extractIdsFromNodes(child, ids);
      });
    }
    const { setFilterNotIn } = this.props;
    setFilterNotIn(ids);
  };

  saveTree = id => e => {
    const { saveTree, deleteTree } = this.props;
    const tree = this.state.nodes;
    //console.log(this.state.nodes);
    // saveTree({ id: id, tree: this.state.nodes });
    // const nodes = clone(this.state.nodes);
    // nodes.root.ch.push({ id: 44, nameFr: "kooora" });
    // this.setState({
    //   nodes: nodes
    // });
    let nodes = null;
    if (tree && tree.root) {
      nodes = {
        root: {
          id: tree.root.id
        }
      };
      if (tree.root.ch) {
        nodes.root.ch = this.getNodeChildren(tree.root.ch);
      }
    }
    if (id === 0) {
      saveTree({ id: null, tree: nodes }).then(resp => {
        this.setState({
          activateEdit: false,
          nodes: null
        });
        return resp;
      });
    } else {
      if (nodes) {
        saveTree({ id: id, tree: nodes }).then(resp => {
          this.setState({
            activateEdit: false
          });
        });
      } else {
        deleteTree(id);
      }
    }
  };

  renderBranches(branch) {
    const { activateEdit } = this.state;
    const { tree } = this.props;
    const id = tree ? tree.id : 0;
    if (!branch || !branch.ch || branch.ch.length === 0) {
      return null;
    }
    return React.createElement(
      "ul",
      { className: styles.child },
      branch.ch.map(
        child =>
          child ? (
            <li className={classnames(styles.branch, styles.layer)}>
              <Branch
                layer={1}
                id={branch.id}
                branch={child}
                onRemove={this.handleRemove.bind(this)}
                onChange={this.handleChange}
                activateEdit={activateEdit}
                onClickAdd={e => this.setEditionMode(id)}
              />
              {this.renderBranches({ ...child })}
              {!activateEdit ? null : (
                <ul className={classnames(styles.child)}>
                  <li className={classnames(styles.branch, styles.layer)}>
                    <Branch
                      id={child.id}
                      onRemove={this.handleRemove.bind(this)}
                      onChange={this.handleChange}
                      activateEdit={activateEdit}
                      onClickAdd={e => this.setEditionMode(id)}
                    />
                  </li>
                </ul>
              )}
            </li>
          ) : null
      )
    );
  }

  render() {
    const { activateEdit, nodes } = this.state;
    const { tree, currentTreeId, saving } = this.props;
    // const { root } = this.state.nodes;
    // const root = tree ? tree.tree.root : null;
    // const root = this.state.nodes ? this.state.nodes.root : null;
    const id = tree ? tree.id : 0;
    const rootId = nodes && nodes.root ? nodes.root.id : 0;

    return (
      <div className={styles.category}>
        {nodes ? (
          <div className={classnames(styles.root, styles.layer)}>
            &nbsp;
            <Branch
              layer={0}
              branch={this.state.nodes.root}
              onChange={this.handleChange}
              onRemove={this.handleRemove.bind(this)}
              activateEdit={activateEdit}
            />
            {this.renderBranches({ ...this.state.nodes.root })}
            {!activateEdit ? null : (
              <ul className={classnames(styles.child)}>
                <li className={classnames(styles.branch, styles.layer)}>
                  {
                    <Branch
                      id={rootId}
                      onChange={this.handleChange}
                      onRemove={this.handleRemove.bind(this)}
                      activateEdit={activateEdit}
                      onClickAdd={e => this.setEditionMode(id)}
                    />
                  }
                </li>
              </ul>
            )}
          </div>
        ) : (
          <div className={classnames(styles.root, styles.layer)}>
            <Branch
              onChange={this.handleChange}
              onRemove={this.handleRemove.bind(this)}
              activateEdit={activateEdit}
              onClickAdd={e => this.setEditionMode(id)}
            />
          </div>
        )}
        {activateEdit && currentTreeId !== null ? (
          <div className={styles.actions}>
            <button
              className={saving ? styles.pending : styles.save}
              onClick={this.saveTree(id)}
            />
            {/* <button
              className={styles.cancel}
              onClick={e => this.handleDisableEdit()}
            /> */}
            <div
              className={styles.cancel}
              onClick={e => this.handleDisableEdit()}
            >
              <span>{_("Close")}</span>
              <i className="icotam-close" />
            </div>
          </div>
        ) : null}
        {currentTreeId === null ? (
          <div
            className={styles.edit}
            onClick={e => this.handleActivateEdit(id)}
          >
            <span>{_("édite")}</span>
            <i className="icon icon-pencil" />
          </div>
        ) : null}
      </div>
    );
    // } else {
    //   return (
    //     <div className={styles.category}>
    //       <div className={classnames(styles.root, styles.layer)}>
    //         <Branch onChange={this.handleChange} />
    //         {!activateEdit ? null : (
    //           <ul className={classnames(styles.child)}>
    //             <li className={classnames(styles.branch, styles.layer)}>
    //               <Branch onChange={this.handleChange} />
    //             </li>
    //           </ul>
    //         )}
    //       </div>
    //       {activateEdit ? (
    //         <div className={styles.actions}>
    //           <button className={styles.save} onClick={this.saveTree(id)} />
    //           <button
    //             className={styles.cancel}
    //             onClick={e => {
    //               this.setState({ activateEdit: false });
    //             }}
    //           />
    //         </div>
    //       ) : (
    //         <div
    //           className={styles.edit}
    //           onClick={this.handleActivateEdit.bind(this)}
    //         >
    //           <span>{_("édite")}</span>
    //           <i className="icon icon-pencil" />
    //         </div>
    //       )}
    //     </div>
    //   );
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriesList/Category/CategoryComponent.js